export default "__VITE_ASSET__2a291b96__"